import React, { useState } from 'react';
import cx from 'classnames';
import { useForm } from 'react-hook-form';

import { Input } from '../../Input';
import InputPhone from '../../InputPhone';
import { TRANSLATIONS } from '../../../../translations';
import { getCompanyTypeOptions } from '../../../utils/companyTypeOptions';

const PartnerUpdateForm = ({ user, onSubmit, prefixesAreVisible }) => {
  const companyTypeOptions = getCompanyTypeOptions();
  const { handleSubmit, register, errors, watch } = useForm();
  const watchCompanyType = watch('company_type');
  const handlePrivacyClick = () => {
    document.getElementById('iubenda-privacy-trigger').click();
  };
  const [firstName, setFirstName] = useState(user.first_name ?? '');
  const [lastName, setLastName] = useState(user.last_name ?? '');
  const [phoneNumber, setPhoneNumber] = useState(user.phone ?? '');
  const [businessName, setBusinessName] = useState(user.business_name ?? '');

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
      <p className={'text-center'}>{app_main_wpml.complete_form}</p>

      <div
        className={cx(
          'input-container',
          'input__modal',
          'dataset__select-container'
        )}
      >
        <select
          name="company_type"
          ref={register({
            required: true,
          })}
          className={cx(
            'dataset-field-input',
            'input',
            'dataset__field--select',
            { 'input-container__label--errored': errors['company_type'] }
          )}
        >
          <option value={''}>{TRANSLATIONS.LEGAL_CLASSIFICATION}</option>
          {Object.entries(companyTypeOptions).map(([k, v]) => (
            <option value={k} key={k}>
              {v}
            </option>
          ))}
        </select>
      </div>

      <Input
        label={TRANSLATIONS.BUSINESS_NAME}
        className={'input__modal'}
        name="business_name"
        errored={!!errors['business_name']}
        defaultValue={businessName}
        onChange={(e) => setBusinessName(e.target.value)}
        setRef={register({
          required: true,
        })}
      />

      <Input
        label={app_main_wpml.first_name}
        className={'input__modal'}
        name="first_name"
        errored={!!errors['first_name']}
        defaultValue={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        setRef={register({
          required: true,
        })}
      />

      <Input
        label={app_main_wpml.last_name}
        className={'input__modal'}
        name="last_name"
        errored={!!errors['last_name']}
        defaultValue={lastName}
        onChange={(e) => setLastName(e.target.value)}
        setRef={register({
          required: true,
        })}
      />

      {['individual', 'individual_company'].includes(watchCompanyType) && (
        <Input
          label={TRANSLATIONS.TAX_ID}
          className={'input__modal'}
          name="tax_id"
          errored={!!errors.tax_id}
          setRef={register({
            required: true,
          })}
        />
      )}

      {['company', 'association', 'individual_company'].includes(
        watchCompanyType
      ) && (
          <Input
            label={TRANSLATIONS.VAT_NUMBER}
            className={'input__modal'}
            name="vat_number"
            errored={!!errors.vat_number}
            setRef={register({
              required: true,
            })}
          />
        )}

      {prefixesAreVisible === '1' ? (
        <InputPhone
          className={'input__modal'}
          errored={!!errors['phone']}
          label={TRANSLATIONS.PHONE}
          name="phone"
          value={phoneNumber}
          setRef={register({
            required: true,
          })}
        />
      ) : (
        <Input
          label={TRANSLATIONS.PHONE}
          className={'input__modal'}
          name="phone"
          errored={!!errors['phone']}
          defaultValue={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          setRef={register({
            required: true,
          })}
        />
      )}

      <Input
        label={TRANSLATIONS.WEBSITE}
        className={'input__modal'}
        name="website"
        errored={!!errors['website']}
        setRef={register({
          required: true,
        })}
      />

      <div
        className={cx('fake-checkbox', {
          'fake-checkbox--errored': !!errors.privacy,
        })}
        style={{ marginLeft: 5, marginTop: 5 }}
      >
        <input
          className="fake-checkbox__input"
          type="checkbox"
          name="privacy"
          ref={register({ required: true })}
          id="partner-signup-privacy"
        />
        <label
          htmlFor="partner-signup-privacy"
          className="fake-checkbox__label"
        >
          <span class="iconify inline" data-icon="mdi:check-bold"></span>
        </label>
        <p className="fake-checkbox__text">
          {app_main_wpml.privacy_acceptance}{' '}
          <span className="fake-checkbox__link" onClick={handlePrivacyClick}>
            {app_main_wpml.privacy_cta}
          </span>
        </p>
      </div>

      <button type="submit" className="btn btn--primary btn--expanded">
        {app_main_wpml.contact_send}
      </button>
    </form>
  );
};

export default PartnerUpdateForm;
